import { render, staticRenderFns } from "./SupplierProgressChips.vue?vue&type=template&id=272ef092&scoped=true"
import script from "./SupplierProgressChips.vue?vue&type=script&lang=js"
export * from "./SupplierProgressChips.vue?vue&type=script&lang=js"
import style0 from "./SupplierProgressChips.vue?vue&type=style&index=0&id=272ef092&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272ef092",
  null
  
)

export default component.exports